var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{style:({ width: '100%', height: `${_vm.height}` + 'px' }),attrs:{"center":{ lat: Number(_vm.bngLat), lng: Number(_vm.bngLng) },"zoom":7,"map-type-id":"terrain"}},_vm._l((_vm.trucks),function(s){return _c('GmapMarker',{key:s.unit_id,attrs:{"position":{ lat: Number(s.latitude), lng: Number(s.longitude) },"clickable":true,"icon":{
        url: require(`../../../public/img/icon/trucks.png`),
        size: { width: 96, height: 48, f: 'px', b: 'px' },
        scaledSize: { width: 96, height: 48, f: 'px', b: 'px' },
      }},on:{"click":function($event){return _vm.toStatus(s.station._id)}}},[_c('GmapInfoWindow',{attrs:{"position":{ lat: Number(s.latitude), lng: Number(s.longitude) }}},[_vm._v(" "+_vm._s(s.licenseplate)+" ")]),_c('GmapCircle',{attrs:{"center":{ lat: Number(s.latitude), lng: Number(s.longitude) },"radius":7000,"visible":true,"options":{
          strokeColor: `${_vm.colorStation(s)}`,
          strokeOpacity: 0.05,
          strokeWeight: 10,
          fillColor: `${_vm.colorStation(s)}`,
          fillOpacity: 0.05,
        }}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }